import { weaponRowTemplate } from "./views/weaponRowTemplate.js"
import { sendData } from "./data.js";
import { API, overlay, root, smoothboreCategoryURL } from "./config.js";
import { getLocation } from "./healpers.js";
import { loadWeaponPage } from "./weapon.js";

const createWeaponList = (parentElem, className, place) => {
    const element = document.createElement('div')
    element.classList.add(className)
    document.querySelector(`${parentElem}`).insertAdjacentElement(place, element)
    return element
}

let weaponListElem = createWeaponList('#root', 'weapon-list', 'beforeend');
const weapon = {}
let position = '';

const replaceNull = (obj) => {
    for (let key in obj) {
        if (obj[key] === null) {
            obj[key] = '';
        }
    }
}

const getPositionNumber = (data) => {
    return position = data.length
}

const updatePosition = () => {
    const type = document.querySelector('input[name="type"]')
    const positions = document.querySelectorAll('.trow-main input[name="position"]');
    const ids = document.querySelectorAll('.trow-main input[name="id"]');
    let pos = {
        type: type.value,
        armaments: {}
    };

    positions.forEach((position, index) => position.value = index + 1)

    ids.forEach((id, index) => {
        const name = id.value
        pos.armaments[name] = positions[index].value
    })
    sendData(`${API}update-armament-positions`, pos)
}

const increasePosition = () => {
    const rows = document.querySelectorAll('.trow')
    position = rows.length + 1
    return position
}

const getColumnsSettings = () => {
    let columnSettings = JSON.parse(localStorage.getItem(`${getLocation() === smoothboreCategoryURL ? 'smoothboreSettings' : 'rifledSettings'}`));

    if (columnSettings === null) {
        columnSettings = []
    }
    return columnSettings
}

const renderWeaponList = (data) => {
    weaponListElem = document.querySelector('.weapon-list') ? document.querySelector('.weapon-list') : createWeaponList('#root', 'weapon-list', 'beforeend');
    weaponListElem.innerHTML = '';
    const location = getLocation()
    data.forEach(weapon => {
        const row = creatRow();
        let index = 0;

        replaceNull(weapon)

        row.insertAdjacentHTML('beforeend', weaponRowTemplate({ 
            data: weapon, 
            class: 'trow-main', 
            index: undefined, 
            column: getColumnsSettings(), 
            type: location,
         }))

        if (weapon.children !== '') {

            weapon.children.forEach(child => {
                index++
                row.insertAdjacentHTML('beforeend', weaponRowTemplate({ 
                    data: child, 
                    class: 'trow-sub', 
                    index: index, 
                    column: getColumnsSettings(),
                    type: location, 
                }))
            })
        }
    });
}

const checkScroll = () => {
    const scrollBarContainer = document.querySelector('.thead-data-scroll')
    const rowsDataFixed = document.querySelectorAll('.trow-data-fixed')
    const rowsDataScroll = document.querySelectorAll('.trow-data-scroll')

    if (scrollBarContainer.scrollLeft > 0) {
        rowsDataFixed.forEach(row => row.classList.add('data-fixed--active'))
        rowsDataScroll.forEach(row => row.style.transform = `translateX(-${scrollBarContainer.scrollLeft}px)`)
    }
}

const search = (data) => {
    const searchElem = document.querySelector('.header-search-input')

    searchElem.addEventListener('input', e => {
        const value = e.target.value;
        weaponListElem.textContent = '';

        const result = data.filter(item => {
            return item.name.toLowerCase().includes(value.toLowerCase())
        })
        renderWeaponList(result)
        checkScroll()
    })

}

const creatRow = () => {
    const row = document.createElement('div')
    row.classList.add('trow')
    weaponListElem.append(row)
    return row
}


export const addNewRow = () => {
    increasePosition()
    const row = creatRow()
    const obj = { position: position }

    row.insertAdjacentHTML(
        'beforeend', 
        weaponRowTemplate({ 
            data: obj, 
            class: 'trow-main', 
            index: undefined, 
            column: getColumnsSettings(), 
            editble: true,
            type: getLocation(),
         })
    )
    window.scroll({
        top: weaponListElem.scrollHeight,
        left: 0,
        behavior: 'smooth'
    })

    checkScroll()

    row.querySelector('.trow-line').classList.add('editble')
    setTimeout(() => { row.querySelector('input[name="manufacturer"]').focus() }, 1000)
}

const addNewSubRow = (target) => {
    const container = target.closest('.trow')
    position = container.querySelector('input[name="position"]').value;
    const parentId = container.querySelector('input[name="id"]');

    const obj = {
        parent_id: parentId.value,
        position: position
    }
    let subPosition;

    if (container.querySelectorAll('.trow-sub')) {
        subPosition = container.querySelectorAll('.trow-sub').length + 1;
    } else {
        subPosition = 1;
    }

    container.insertAdjacentHTML('beforeend', weaponRowTemplate(
        {
            data: obj,
            class: 'trow-sub',
            index: subPosition,
            column: getColumnsSettings(),
            editble: true,
            type: getLocation(),
        }
    ))
}

const replaceLinkOnInput = (row) => {
    const link = row.querySelector('.trow-link')
    const text = link.textContent;
    const input = document.createElement('input')

    input.setAttribute('type', 'text')
    input.setAttribute('name', 'name')
    input.value = text

    link.replaceWith(input)
}
// Заменить input на ссылку. 
const replaceInputOnLink = (input, row) => {
    const id = row.querySelector('input[name="id"]').value;
    const link =  document.createElement('a') 
    const value = input.value;

    link.classList.add('trow-link')
    link.textContent = value;
    link.href = `weapon.html?id=${id}`;

    input.replaceWith(link)
}

const editRow = (target) => {
    const line = target.closest('.trow-line');
    const inputs = line.querySelectorAll('input')
    const selects = line.querySelectorAll('select')
    
    replaceLinkOnInput(line)

    inputs.forEach(input => {
        input.removeAttribute('readonly');
    })
    selects.forEach(select => {
        select.removeAttribute('disabled');
    })
    line.classList.add('editble')
    line.querySelector('.icons-first').classList.add('hidden')
    line.querySelector('.icons-second').classList.remove('hidden')
}

const saveRow = (target, inputs, attribute) => {
    const line = target.closest('.trow-line')

    line.querySelectorAll(inputs).forEach(input => {
        const name = input.getAttribute('name');
        const value = input.value;
        weapon[name] = value;
        input.setAttribute(attribute, attribute);
    })

    line.classList.remove('editble')
    line.querySelector('.icons-first').classList.remove('hidden')
    line.querySelector('.icons-second').classList.add('hidden')
}

const deleteRow = (target) => {
    const container = target.closest('.trow-line')
    const obj = {
        type: container.querySelector('input[name="type"]').value,
        id: container.querySelector('input[name="id"]').value,
    }
    sendData(`${API}delete-armament`, obj)
    if (target.closest('.trow-main')) {
        container.closest('.trow').remove()
    } else {
        target.closest('.trow-sub').remove()
    }
    updatePosition()
}

const dragAndDrop = () => {
    const rows = document.querySelectorAll('.trow');
    let current = null;

    for (let row of rows) {
        row.setAttribute('draggable', 'true')
        row.addEventListener('dragstart', (e) => {
            current = row;
            for (let it of rows) {
                if (it != current) { it.classList.add("hint"); }
            }
        })

        row.addEventListener('dragenter', (e) => {
            if (row != current) { row.classList.add("dropzone"); }
        })

        row.addEventListener('dragleave', () => {
            row.classList.remove("dropzone");
        })

        row.addEventListener('dragend', () => {
            for (let it of rows) {
                it.classList.remove('hint');
                it.classList.remove('dropzone');
            }
        })

        row.addEventListener('dragover', e => e.preventDefault())

        row.addEventListener('drop', (e) => {
            e.preventDefault();
            if (row != current) {
                let currentpos = 0, droppedpos = 0;

                for (let i = 0; i < rows.length; i++) {
                    if (current == rows[i]) { currentpos = i; }
                    if (row == rows[i]) { droppedpos = i; }
                }

                if (currentpos < droppedpos) {
                    row.parentNode.insertBefore(current, row.nextSibling);
                } else {
                    row.parentNode.insertBefore(current, row);
                }
            }

            row.removeAttribute('draggable');
            const positions = document.querySelectorAll('.trow-main input[name="position"]');
            const ids = document.querySelectorAll('.trow-main input[name="id"]');
            let pos = {
                type: row.querySelector('input[name="type"]').value,
                armaments: {}
            };

            positions.forEach((position, index) => position.value = index + 1)

            ids.forEach((id, index) => {
                const name = id.value
                pos.armaments[name] = positions[index].value
            })
            sendData(`${API}update-armament-positions`, pos)
        })
    }

}

const horizontalScroll = () => {
    const scrollBarContainer = document.querySelector('.thead-data-scroll')
    const fixedThead = document.querySelector('.thead-data-fixed')

    scrollBarContainer.addEventListener('scroll', e => {

        const rowsDataFixed = document.querySelectorAll('.trow-data-fixed')
        const rowsDataScroll = document.querySelectorAll('.trow-data-scroll')

        if (e.target.scrollLeft > 0) {
            fixedThead.classList.add('data-fixed--active')
            rowsDataFixed.forEach(row => row.classList.add('data-fixed--active'))
            rowsDataScroll.forEach(row => row.style.transform = `translateX(-${e.target.scrollLeft}px)`)
        }

        if (e.target.scrollLeft === 0) {
            {
                fixedThead.classList.remove('data-fixed--active')
                rowsDataFixed.forEach(row => row.classList.remove('data-fixed--active'))
            }
        }

    })
}

const collapsible = () => {
    const headerSettingsBtn = document.querySelector('.header-settings');
    const headerSettingsContainer = document.querySelector('.header-settings-container');

    headerSettingsBtn.addEventListener('click', () => headerSettingsContainer.classList.toggle('active'));

    headerSettingsContainer.addEventListener('click', e => {

        const dataColumns = document.querySelectorAll('.data-col');

        if (e.target.classList.contains('header-settings__name')) {
            const dataColBtn = e.target.dataset.column;
            for (const col of dataColumns) {
                if (col.dataset.collapsible === dataColBtn) {
                    col.classList.toggle('hidden');
                }
            }
        }

        if (e.target.classList.contains('header-settings-save')) {
            const inputs = headerSettingsContainer.querySelectorAll('input');
            const settings = [];

            inputs.forEach(input => {
                const obj = {
                    name: input.getAttribute('name'),
                    open: input.checked,
                    column: input.dataset.columnNumber,
                    columnType: input.dataset.type,
                    filter: input.dataset.hasFilter,
                }
                settings.push(obj)
            })
            localStorage.setItem(`${getLocation() === smoothboreCategoryURL ? 'smoothboreSettings' : 'rifledSettings'}`, JSON.stringify(settings));
            headerSettingsContainer.classList.remove('active')
        }
    })
}

const weaponListEvents = () => {

    weaponListElem.addEventListener('click', e => {
        const target = e.target;

        if (target.classList.contains('edit-item')) {
            editRow(target)
        }

        if (target.classList.contains('save-item')) {
            const line = target.closest('.trow-line')
            const model = line.querySelector('input[name="name"]')

            if (model.value.length >= 3) {
                saveRow(target, 'input', 'readonly')
                saveRow(target, 'select', 'disabled')
                sendData(`${API}armaments`, weapon)
                .then(data => {
                    const id = line.querySelector('input[name="id"]')
                    id.value = data.data.id;
                })
                replaceInputOnLink(model, line)

            }

            if (model.value.length < 3) {
                line.classList.add('data-error')
                line.querySelector('.trow-data-error-mes').classList.add('active')

                setTimeout(() => {
                    line.classList.remove('data-error')
                    line.querySelector('.trow-data-error-mes').classList.remove('active')
                }, 1000)
            }
        }

        if (target.classList.contains('add-sub-item')) {
            addNewSubRow(target)
        }

        if (target.classList.contains('delete-item')) {
            deleteRow(target)
        }

        if (target.classList.contains('drag-item')) {
            dragAndDrop()
        }
        if(target.classList.contains('trow-link')) {
            e.preventDefault()
            const weaponID = target.getAttribute('href').slice(1);
            loadWeaponPage(weaponID)
        }
    })

    weaponListElem.addEventListener('mousedown', e => {
        const target = e.target;
        if (target.classList.contains('drag-item')) {
            dragAndDrop()
        }
    })
}

const createFilterContainer = (arr, type) => {

    const filterContainerElem = document.createElement('div')
    let filterContainerInnerHTML = '';

    filterContainerElem.classList.add('thead-filter')
    filterContainerElem.dataset.filterContainer = type

    arr.add('Все')
    arr.forEach(value => {
        filterContainerInnerHTML += `
         <label class="thead-filter__name">
            <input type="radio" name="filter-column" value="${value}">
             <div class="thead-filter__checkbox">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
             </div>
             <div>${value === '' ? 'Не заполнено' : value}</div>
         </label>  
        `;
    })

    filterContainerElem.innerHTML = filterContainerInnerHTML;
    root.append(filterContainerElem)
}

const filterRows = (value, spec, data) => {
    return data.filter(item => item[spec] === value)
}

const closeFilterContainer = () => {
    const filterContainers = document.querySelectorAll('.thead-filter')
    filterContainers.forEach(container => container.style.display = 'none')
    overlay.classList.remove('active')
}

const showFilterContainer = (target) => {
    const element = target.closest('.thead-data');
    const container = document.querySelector(`.thead-filter[data-filter-container="${element.dataset.columnType}"]`)

    container.style.left = `${element.offsetLeft - document.querySelector('.thead-data-scroll').scrollLeft}px`
    container.style.display = 'block';
    overlay.classList.add('active');
}

const filterEvents = (data) => {
    const filterColumnsHead = document.querySelector('.thead-data-scroll')
    const filterContainers = document.querySelectorAll('.thead-filter')

    filterColumnsHead.addEventListener('click', e => {
        if (e.target.classList.contains('filter-btn')) {
            showFilterContainer(e.target)
        }
    })

    filterContainers.forEach(container => {
        container.addEventListener('click', e => {
            const btn = e.target.closest('.thead-filter__name')
            if (!btn) return;

            const btnInput = btn.querySelector('input')
            btnInput.checked = true
            if (btnInput.value === 'Все') {
                renderWeaponList(data)
                checkScroll()
            } else {
                renderWeaponList(filterRows(btnInput.value, container.dataset.filterContainer, data))
                checkScroll()
            }
            closeFilterContainer()
        })
    })

    overlay.addEventListener('click', closeFilterContainer)
}

const createFilters = (data) => {
    const filterColumns = document.querySelectorAll('.thead-data[data-column-type]')
    const filterValues = {
        bulletLength: new Set(),
        caliber: new Set(),
        subtype: new Set(),
        trigger: new Set(),
        case: new Set(),
    }

    data.forEach(obj => {
        for (let keyA in obj) {
            for (let keyB in filterValues) {
                if (keyA === keyB) {
                    filterValues[keyB].add(obj[keyA])
                }
            }
        }
    })
    filterColumns.forEach(column => {
        const columnType = column.dataset.columnType;

        if (filterValues[columnType] !== undefined) {
            createFilterContainer(filterValues[columnType], columnType)
        }
    })
    filterEvents(data)
}

export const initList = (data) => {
    renderWeaponList(data)
    search(data)
    getPositionNumber(data)
    horizontalScroll()
    collapsible()
    weaponListEvents()
    createFilters(data)
}




